var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,110a66.37,66.37,0,0,0-10,.76A64.94,64.94,0,0,0,35,175v5H165v-5A65.08,65.08,0,0,0,100,110ZM45.22,170a54.19,54.19,0,0,1,2.91-13.33,55,55,0,0,1,26.15-30.32l14.18,14.19,7.08-7.08-11.21-11.2a54.16,54.16,0,0,1,7.21-1.61,55.19,55.19,0,0,1,24.11,1.62l-11.19,11.19,7.08,7.08,14.14-14.15A55.06,55.06,0,0,1,154.77,170ZM75.28,79.75a35,35,0,0,1,49.5-49.5l-7.08,7.07a25,25,0,1,0,0,35.36l7.08,7.07a35,35,0,0,1-49.5,0ZM100,137.93l7.07,7.07L100,152.07,92.93,145ZM135,50V35h10V50h15V60H145V75H135V60H120V50Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPlus);
export default __webpack_public_path__ + "static/media/person-plus.c837786e45357f0dec343b6c7c9fa974.svg";
export { ForwardRef as ReactComponent };